import { useEffect } from 'react';
import FJFake3dLeftContainer from './FJFake3dLeft/FJFake3dLeftContainer';
import FJFake3dRightContainer from './FJFake3dRight/FJFake3dRightContainer';
import { useDispatch } from 'react-redux';
import FJActionFake3d from '../../redux/action/FJActionFake3d';

const FJFake3d = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionFake3d.initFake3dProjectActon());
    }, [dispatch]);
    return (
        <>
            <FJFake3dLeftContainer />
            <FJFake3dRightContainer />
        </>
    );
};

export default FJFake3d;
